import React, { useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import ToolsBar from "./toolsBar";
import PaginationNav from "./paginationNav";
import FormTitle from "components/formTitle";
import logger from "utils/logger";
import GridTable from "./gridTable";
import data from "services/data";

const StyledMiniPluginInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

const tablePageSize = 6;

const MiniPluginInfo = ({ onPluginChange }) => {
  const [keyword, setKeyword] = useState("");
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const updateItems = useCallback(
    async (pageSize, currentPage) => {
      const { totalCount, pluginList } = await data.getPluginInfoList(
        pageSize,
        currentPage,
        keyword
      );
      setItems(pluginList);
      setTotal(totalCount);
    },
    [keyword]
  );

  const handleSearch = useCallback(() => {
    updateItems(tablePageSize, 1);
    setCurrentPage(1);
  }, [updateItems]);

  const handleCurrentPageChange = useCallback(
    (pageNum) => {
      setCurrentPage(pageNum);
      updateItems(tablePageSize, pageNum);
    },
    [updateItems]
  );

  useEffect(() => {
    updateItems(tablePageSize, 1);
  }, []);

  return (
    <StyledMiniPluginInfo>
      {/* <FormTitle size="15px">搜索插件版本</FormTitle> */}
      <ToolsBar
        mode="mini"
        search={{
          value: keyword,
          setValue: setKeyword,
          onSearch: handleSearch,
          placeholder: "搜索插件...",
        }}
      />
      <GridTable
        mode="mini"
        items={items}
        heads={["名称", "别名", "安装路径", "简介"]}
        paths={["module", "aliasName", "installPath", "info"]}
        rowCursor="pointer"
        rowClick={(data) => {
          logger.log("这行的插件信息：", data);
          onPluginChange && onPluginChange(data);
        }}
      />
      <PaginationNav
        mode="mini"
        total={total}
        pageSize={tablePageSize}
        currentPage={currentPage}
        onCurrentPageChange={handleCurrentPageChange}
      />
    </StyledMiniPluginInfo>
  );
};

export default MiniPluginInfo;
